import { useConfig } from '../../../providers/envConfig'
import { AccountResponseWithConsentDetails } from '../../../types/Account'
import useFetch from '../../helpers/useFetch'

// useGetByID is a custom hook to fetch data from the /accounts/{id} endpoint.
const useGetByID = (id: string, jwt: string) => {
  const envConfig = useConfig()

  const url = `${envConfig.vpcUrl}/accounts/${id}`
  const fields: RequestInit = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'x-bnet-key': envConfig.bnetKey,
      Authorization: `Bearer ${jwt}`,
    },
    credentials: 'include',
  }

  const { data, loading, error, callFetch } = useFetch<AccountResponseWithConsentDetails>(
    url,
    fields,
  )

  return { data, loading, error, callFetch }
}

export default useGetByID
